import { BaseRatePageAction, BaseRateState } from './interfaces';

export const initialBaseRateState: BaseRateState = {
  crud: { open: false, record: null, mode: null, draft: null },
  deleteModal: { open: false, record: null },
};

export function baseRateReducer(prevState: BaseRateState, action: BaseRatePageAction): BaseRateState {
  switch (action.type) {
    case 'openCrud':
      return {
        ...initialBaseRateState,
        crud: { open: true, record: action.record ?? null, mode: action.mode, draft: action.draft ?? null },
      };
    case 'closeCrud':
      return {
        ...initialBaseRateState,
      };
    case 'openDeleteModal':
      return {
        ...prevState,
        deleteModal: {
          open: true,
          record: action.record,
        },
      };
    case 'closeDeleteModal':
      return {
        ...prevState,
        deleteModal: {
          open: false,
          record: null,
        },
      };
    default:
      throw new Error('No action provided');
  }
}
